import styled from 'styled-components';

export const OverviewNote = styled.p`
  font-size: 14px;
  line-height: 150%;
  color: ${(prop) => prop.theme.colors['neutral-90']};
  margin-bottom: 12px;
`;

export const ScoreAndExpandBox = styled.div`
  background: ${(props) => props.theme.colors['neutral-20']};
  border: 1px solid ${(props) => props.theme.colors['neutral-40']};
  border-radius: 4px;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
`;

export const ReviewerScoreBox = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  color: ${(prop) => prop.theme.colors['neutral-70']};

  span {
    color: ${(prop) => prop.theme.colors['primary-60']};
  }
`;

export const ExpandBox = styled.button`
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 150%;
  color: ${(prop) => prop.theme.colors['neutral-90']};

  svg {
    font-size 14px;
    margin-left: 6px;
  }
`;
